<script lang="ts">
	import { getGlobalSettings } from "../../contexts/getGlobalSettings.js";

	const { COOKIES } = getGlobalSettings();

	/* eslint-disable svelte/no-at-html-tags */
</script>

<svelte:head>
	{#if COOKIES}
		<link rel="preconnect" href="https://cdn.cookie-script.com" />
	{/if}
</svelte:head>

{#if COOKIES}
	{@html `<script type="text/javascript" charset="UTF-8" src="https://cdn.cookie-script.com/s/${COOKIES}.js" fetchpriority="low"></script>`}
{/if}
